<template>
	<div style="padding: 10px">
		<div v-if="offers.length > 0">
			<div style="margin-top: 2em" v-for="state in states" :key="state.state">
				<div v-if="offers.filter((o) => o.state === state.state).length > 0">
					<h1>{{ state.text }}</h1>
					<v-data-table
						:items="offers.filter((o) => o.state === state.state)"
						:headers="[
							{ text: 'Status', value: 'state' },
							{ text: 'Id', value: 'id' },
							{ text: 'Eingereicht am', value: 'requestedAt' },
							{ text: 'Spätester Liefertermin', value: '' },
						]"
						hide-actions
					>
						<template slot="items" slot-scope="props">
							<tr>
								<td class="text-xs-left">
									<v-icon color="accent">
										{{ state.icon }}
									</v-icon>
								</td>
								<td>
									{{ props.item.calculationId }}
								</td>
								<td>
									{{ props.item.requestedAt | formatDate }}
								</td>
								<td>
									{{ props.item.latestDeliveryDate | formatDate }}
								</td>
								<td>
									<v-btn
										class="blexon-button"
										@click="navigateTo(props.item.calculationId)"
										>Öffnen</v-btn
									>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
		</div>
		<div v-else>
			Noch keine Angebote vorhanden. Sie erhalten eine E-Mail Benachrichtigung, sobald eine
			Anfrage gestellt wird.
		</div>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	props: {},
	data() {
		return {
			offers: [],
			states: [
				{
					state: 0,
					text: "Offene Angebote",
					icon: "quiz",
				},
				{
					state: 1,
					text: "Abgegebene Angebote",
					icon: "hourglass_top",
				},
				{
					state: 2,
					text: "Bestätigte Aufträge",
					icon: "check_box",
				},
				{
					state: 3,
					text: "Abgelehnte Angebote",
					icon: "disabled_by_default",
				},
			],
		};
	},
	mounted() {
		this.loadOffers();
	},
	methods: {
		async loadOffers() {
			try {
				const response = await httpClient().get(
					`api/Offer/GetOffers?fertigerId=${this.$route.params.fertigerId}`
				);
				this.offers = response.data;
			} catch (err) {
				console.log(err);
			} finally {
				this.$emit("loading", false);
			}
		},

		navigateTo(calculationId) {
			var fertigerId = this.$route.params.fertigerId;
			this.$router.push({
				name: "offer",
				params: { fertigerId: fertigerId, calculationId: calculationId },
			});
		},
	},
};
</script>
